import { render } from "./FormOrderComponent.vue?vue&type=template&id=6b10efe6"
import script from "./FormOrderComponent.vue?vue&type=script&lang=js"
export * from "./FormOrderComponent.vue?vue&type=script&lang=js"

import "./FormOrderComponent.vue?vue&type=style&index=0&id=6b10efe6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__